/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Sair do CD
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 12/04/2013
 */

import { DefaultRequest } from 'scripts/api';

Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.DepartOrigin = function (
  {
    parentSelector = '#RouteSummary',
    successCallback
  } = {}
) {

    this.modalForm = null;
    this.route = null;
    this.blockOverlaySelector = '.mainContainer';

    this.show = function () {
        this.modalForm.showModalForm();
    };

    this.setRoute = function (route) {
        this.route = route;
    };

    this.prepareToCreateForm = function () {

        var util = new Greenmile.Route.ModalUtils();
        util.ajustModalOverlay(this.blockOverlaySelector);

    };

    /**
     * Monta a estrutura base do formulário, pega o template e insere o conteúdo no modalForm
     */

    this.createForm = function () {
        const modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);
        const date = new Monet.Date.GeneralFunctions();

        if (modalContainer !== null) {
            const layout = {
                "items": [
                    {
                        "tag": "form",
                        "items": [
                            {
                                "items": [
                                    {
                                        "attributes": {
                                            "class": "monetInlineAlerContainer"
                                        }
                                    },
                                    {
                                        "items": [
                                            {
                                                "attributes": {
                                                    "class": "popup-modal-header"
                                                },
                                                "items": [
                                                    {
                                                        "tag": "h3",
                                                        "html": Monet.I18n.getResourcesByKey('Greenmile.Route.DepartOrigin.btnSave'),
                                                    },
                                                    {
                                                        "tag": "div",
                                                        "items": [
                                                            {
                                                                "tag": "a",
                                                                "attributes": {
                                                                    "href": "https://greenmile.help.descartesservices.com",
                                                                    "class": "MonetUIHelpLink",
                                                                    "title": "Help"
                                                                },
                                                            }
                                                        ],
                                                        "attributes": {
                                                            "class": "MonetUIHelp"
                                                        },
                                                    }
                                                ]
                                            },
                                            {
                                                "tag": "div",
                                                "attributes": {
                                                    "class": "popup-modal-body"
                                                },
                                                "items": [
                                                    {
                                                        "tag": "label",
                                                        "html":  Monet.I18n.getResourcesByKey('Greenmile.Route.DepartOrigin.dateTimeFieldLabel'),
                                                        "attributes": {
                                                            "for": "departOriginTime"
                                                        },
                                                    },
                                                    {
                                                        "tag": "input",
                                                        "attributes": {
                                                            "type": "text",
                                                            "id": "departOriginTime",
                                                            "value": date.getCurrentDateAndTime(),
                                                            "name": "departOriginTime",
                                                            "class": "dateTimePicker"
                                                        }
                                                    },
                                                    {
                                                        "tag": "label",
                                                        "html":  Monet.I18n.getResourcesByKey('Greenmile.Route.DepartOrigin.driversList'),
                                                        "for": "driversList",
                                                        "attributes": {
                                                            "for": "driversList",
                                                        }
                                                    },
                                                    {
                                                        "tag": "select",
                                                        "attributes": {
                                                            "name": "driversList",
                                                            "id": "driversList"
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                "tag": "div",
                                                "attributes": {
                                                    "class": "popup-modal-footer formButtons"
                                                },
                                                "items": [
                                                    {
                                                        "tag": "input",
                                                        "attributes": {
                                                            "type": "button",
                                                            "value": Monet.I18n.getResourcesByKey('Greenmile.Route.DepartOrigin.btnSave'),
                                                            "name": "btn_save_departOrigin_stop",
                                                            "id": "btn_save_departOrigin_stop",
                                                            "class": "btn",
                                                            "style": "width: 170px"
                                                        }
                                                    },
                                                    {
                                                        "tag": "input",
                                                        "attributes": {
                                                            "type": "button",
                                                            "value": Monet.I18n.getResourcesByKey('Greenmile.Route.DepartOrigin.btnExit'),
                                                            "name": "btn_exit_departOrigin_stop",
                                                            "id": "btn_exit_departOrigin_stop",
                                                            "class": "btn secondary",
                                                            "style": "width: 75px"
                                                        }
                                                    }
                                                ],
                                            }
                                        ],
                                    }
                                ],
                                "attributes": {
                                    "class": "row"
                                }
                            }
                        ],
                        "attributes": {
                            "id": "formDepartOriginFormTemplate"
                        }
                    }
                ]
            };

            modalContainer.appendChild((new Monet.UI.LayoutGenerator(layout)).render());

            date.setDateTimePicker(`${parentSelector} .popupFormContainer .dateTimePicker`);

        } else {
            new Monet.Exception.ReturnError(this, "No .popupFormContainer found.")
                .console();
        }
    };

    this.loadData = function () {

        const that = this;

        const data = {
          criteriaChain: [
            {
              and: [
                {
                  attr: "route.id",
                  eq: this.route.get("id")
                }
              ]
            }
          ]
        };
        const request = new DefaultRequest({
            url: 'RouteDriver/restrictions?criteria={"filters" : ["*","driver.name", "driver.id"]}',
            method: 'post',
            data,
            success: function (data) {
                that.populateDriversList(data);
            }
        });
        request.send();

    };

    this.populateDriversList = function (drivers) {
        const undeliverableCodeElement = document.querySelector("#formDepartOriginFormTemplate #driversList");
        const selectDriver = document.querySelector("#driversList");
        const labelDriver = document.querySelector("label[for='driversList']");

        if (typeof(drivers) !== "undefined") {
            if (drivers.length > 0) {
                selectDriver.style.display = 'block';
                labelDriver.style.display = 'block';
                undeliverableCodeElement.innerHTML = "";

                for (let i = 0, j = drivers.length; i < j; i++) {
                    const option = document.createElement("option");

                    option.value = drivers[i].driver.id;
                    option.text = drivers[i].driver.name;

                    undeliverableCodeElement.appendChild(option);
                }
            } else {
                selectDriver.style.display = 'none';
                labelDriver.style.display = 'none';
            }
        } else {
            new Monet.Exception.ReturnError(this,"No collection loaded")
                .console();
        }
    };

    this.addEventListenners = function () {

        var error = null;

        try {

            var that = this;
            var btnSave = document.querySelector("#formDepartOriginFormTemplate #btn_save_departOrigin_stop");
            var btnExit = document.querySelector("#formDepartOriginFormTemplate #btn_exit_departOrigin_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doDepartOrigin();
            };

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No add event listenner to form.");
            error.console();

        }

    };

    this.doDepartOrigin = function () {

        var isValid = this.validateForm();
        var formDataJson = {};
        var that = this;
        var driverParameter = "";
        var error = null;

        if (isValid) {
            this.modalForm.toggleLoadingInModalBtn();
            formDataJson = this.getFormValues();

            if (this.route !== null) {

                if (formDataJson.driverId !== "") {
                    driverParameter = "/Driver?id=" + formDataJson.driverId;
                } else {
                    driverParameter = "/NoDriver";
                }

                const request = new DefaultRequest({
                    url: 'Route/' + this.route.get("id") + '/DepartOrigin' + driverParameter,
                    method: 'post',
                    data: '{"actualDeparture": "' + formDataJson.actualDeparture + '"}',
                    success: function (data) {
                        that.modalForm.closeModalWindow();
                        that.successCallback(data);
                    },
                    error: function (data) {
                        that.modalForm.toggleLoadingInModalBtn();
                        that.modalForm.closeModalWindow();
                        that.errorCallback(data);
                    }
                });
                request.send();

            } else {
                error = new Monet.Exception.ReturnError(this,
                    "route can't be null");
                error.console();
            }
        }

    };

    this.getFormValues = function () {
        var departOriginTimeField = document.querySelector("#formDepartOriginFormTemplate .dateTimePicker");
        var driver = document.getElementById("driversList");
        var formattedDate = Monet.Format.DateTime.parseLocaleToISOString(departOriginTimeField.value);

        return {
            actualDeparture: formattedDate,
            driverId: driver.value
        };
    };

    this.successCallback = function () {
      if (parentSelector === '#RouteSummary') {
        const router = new App.Routers.RouteSummaryRoutes();

        Monet.Grid.Utils.clearPagination('RouteSummaryRoutes');
        router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid, true);
      } else {
        successCallback?.();
      }

    };

    this.errorCallback = function (data) {

        var monetMessage = new Monet.Form.Messages.AlertMessage();

        monetMessage.setInfoType("error");
        monetMessage.setMessage(JSON.parse(data.responseText));
        monetMessage.triggerMessage();

    };

    this.validateForm = function () {

        var isValid = true;
        var error = null;
        var departOriginTime = document.getElementById("departOriginTime");
        var actualDepartOrigin = this.route.get("actualDeparture");
        var utils = new Greenmile.Route.ModalUtils();
        var scopeMessage = '#formDepartOriginFormTemplate';

        var formatToCreate = Monet.I18n.locale.dateFormat + ' ' + Monet.I18n.locale.timeFormat;
        var departOriginTimeTimeMili = null;

        try {

            if (departOriginTime.value.trim() === "") {

                utils.showErrorMessage(scopeMessage, "departOrigin_date", "Route.Start.cantStartWhitouDateTime");

                isValid = false;

            } else {

                departOriginTimeTimeMili = Monet.Format.DateTime.parseLocale(departOriginTime.value).getTime();

                if (typeof(actualDepartOrigin) !== "undefined") {

                    utils.showErrorMessage(scopeMessage, "date_before_route_departOrigin", "Route.DepartOrigin.cantDepartOriginDepartOriginedRoute");

                    isValid = false;

                } else {

                    if (departOriginTimeTimeMili >= new Date().getTime()) {

                        utils.showErrorMessage(scopeMessage, "driver", "Route.Depart.cantDoItTheFuture");

                        isValid = false;

                    }
                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No validate form.");
            error.console();

        }

        return isValid;
    };

    this.createAllStructure = function (scope) {
        return function () {
            scope.prepareToCreateForm();
            scope.createForm();
            scope.loadData();
            scope.addEventListenners();
        };
    }(this);

    const init = function (scope) {

        return function (scope) {

            const selector = parentSelector;

            const options = {
                width: 280,
                height: 250
            };

            const callbacks = {
                onAfterShowModalForm: scope.createAllStructure
            };

            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scope.blockOverlaySelector);

        }(scope);

    };

    init(this);

};
